import { createAction } from '@reduxjs/toolkit';

import { SET_GUIDE, type Guide } from './types';

export const setGuide = createAction<Guide | null, typeof SET_GUIDE>(SET_GUIDE);
